(function () {

    'use strict';

    angular.module('FotocApp')

        .component('images', {

            templateUrl: (USE_TEMPLATE_CACHE ? '' : window.BASE_PATH + '../../src/') + 'editor/tools/images.component.html',
            bindings: {},
            controller: ['$scope', '$editorService', '$tutorialService', '$canvasService', '$http', 'CONSTANTS', '$timeout', '$lang', '$shutterstock', function ($scope, $editorService, $tutorialService, $canvasService, $http, CONSTANTS, $timeout, $lang, $shutterstock) {

                var self = this;
                var widget;

                $scope.$watch("$ctrl.$editorService.ui.type", function () {

                    if ($editorService.ui.uploadCareMultiFile) {
                        $editorService.uploadCare = uploadcare.MultipleWidget('[role=uploadcare-uploader]');
                    } else {
                        $editorService.uploadCare = uploadcare.SingleWidget('[role=uploadcare-uploader]');
                    }

                    $editorService.uploadCare.onChange(function (file_or_group) {

                        if (file_or_group) {

                            var arrayOfFiles;
                            if ($editorService.ui.uploadCareMultiFile) {
                                arrayOfFiles = file_or_group.files();
                            } else {
                                arrayOfFiles = [file_or_group]
                                $canvasService.isLoading = true;
                            }

                            setTimeout(function () {
                                $editorService.ui.toolOpen = 'images';
                                $scope.$apply();
                            }, 0);


                            $.each(arrayOfFiles, function (i, file) {

                                file.done(function (fileInfo) {

                                    $editorService.ui.my_galery = $editorService.ui.my_galery.filter(function (item) {
                                        return !(item.id === -1);
                                    });

                                    if (fileInfo) {

                                        $editorService.ui.my_galery.push({ id: -1 })

                                        setTimeout(function () {
                                            $editorService.ui.toolOpen = 'images';
                                            $scope.$apply();
                                        }, 0);


                                        $editorService.ui.my_galery = $editorService.ui.my_galery.filter(function (item) {
                                            return !(item.id === -1);
                                        });
                                        $editorService.ui.my_galery.push(fileInfo);
                                        setcookie('fotoc_my_galery', JSON.stringify($editorService.ui.my_galery));
                                        self.selectImage(fileInfo, 'my_galery', false);
                                    }
                                });
                            });
                        }
                    });
                })


                this.$shutterstock = $shutterstock;
                this.$editorService = $editorService;

                $scope.$lang = $lang;

                var default_images = [];

                this.$onInit = function () {

                    $scope.$watch('$ctrl.txt_search', function () {

                        if (angular.isDefined(self.txt_search)) {

                            if (self.txt_search == '') {
                                $editorService.ui.images = default_images;
                            } else {
                                $editorService.ui.images = [];
                                $shutterstock.onWatchTxt($editorService.ui.images, self.txt_search);
                            }

                        }

                    })


                    $editorService.openModalUploadCarteFunct = this.upload;


                    var fotoc_my_galery = getCookie('fotoc_my_galery')
                    if (fotoc_my_galery) {

                        $editorService.ui.my_galery = (JSON.parse(getCookie('fotoc_my_galery')));
                        if ($editorService.ui.compositionsAsGroup) {
                            $editorService.data.images = $editorService.ui.my_galery.map(function ($data, $index) {
                                var u = $data.cdnUrl + '-/resize/1024/';
                                // $canvasService.setImage(u, true, $index, false)
                                return {
                                    type: 'my_galery',
                                    frameColor: $editorService.ui.lastFrameColorSelected,
                                    data: $data,
                                    urlWithoutFilter: u,
                                    urlWithFilter: u,
                                    position: { x: 500, y: 500, rotation: 0, scaleX: 1, scaleY: 1 },
                                    userForce: false
                                }
                            });
                            // $editorService.updateLayoutTiles();
                            //$canvasService.makeFromData(true)
                        }
                    }

                    if ($editorService.ui.loadDefaultGallery) {
                        var gallery = $editorService.siteConfig.defaultGallery;
                        self.selectImage(gallery.data[0], 'stock', false);
                        var clearWatch = $scope.$watch('$ctrl.$editorService.ui.toolOpen', function () {
                            if ($editorService.ui.toolOpen === 'images') {
                                clearWatch();
                                $timeout(function () {
                                    default_images = gallery.data;
                                    $editorService.ui.images = default_images;
                                }, 400);
                            }
                        });
                    }
                }

                this.findPosUuid = function ($uuid, test) {
                    var cant = $editorService.data.images.length;
                    for (var i = 0; i < cant; i++) {
                        if ($editorService.data.images[i].data.uuid === $uuid) {
                            return i;
                        }
                    }
                    return false;
                }

                this.toogleTile = function (item, $index) {
                    var pos = self.findPosUuid(item.uuid);
                    $editorService.ui.view = { type: 'edit', id: null };
                    if (pos === false) {

                        item.disabled = false;
                        $editorService.data.images =
                            $editorService.ui.my_galery.filter(function ($item) {
                                return !($item.disabled === true)
                            })
                                .map(function ($item) {

                                    var _pos = self.findPosUuid($item.uuid)
                                    if (_pos !== false) {
                                        return $editorService.data.images[_pos]
                                    } else {
                                        var u = $item.cdnUrl + ($item.fotocOwner ? '' : '-/resize/1024/');
                                        return {
                                            type: 'my_galery',
                                            data: $item,
                                            frameColor: $editorService.ui.lastFrameColorSelected,
                                            urlWithoutFilter: u,
                                            urlWithFilter: u,
                                            position: { x: 500, y: 500, rotation: 0, scaleX: 1, scaleY: 1 },
                                            userForce: true
                                        }
                                    }

                                })

                        var u = item.cdnUrl + (item.fotocOwner ? '' : '-/resize/1024/');
                        $canvasService.setImage(u)
                        $editorService.setCacheImages(u);
                        $editorService.ui.editingItem = self.findPosUuid(item.uuid);

                    } else {
                        item.disabled = true;
                        $editorService.data.images = $editorService.data.images.filter(function (i) {
                            return i.data.uuid !== item.uuid;
                        });

                    }

                    if ($editorService.ui.editingItem > ($editorService.data.images.length - 1)) {
                        $editorService.ui.editingItem = ($editorService.data.images.length - 1);
                    }

                }


                this.removeItemMyGalery = function (item, $index) {

                    $editorService.ui.my_galery = $editorService.ui.my_galery.filter(function (i) {
                        return i.uuid !== item.uuid;
                    });

                    setcookie('fotoc_my_galery', JSON.stringify($editorService.ui.my_galery));

                    if ($editorService.ui.compositionsAsGroup) {

                        $canvasService.stopTick();
                        $editorService.ui.view = { type: 'edit', id: null };
                        $editorService.data.images = $editorService.data.images.filter(function ($im, index) {
                            return index !== $index;
                        });

                        if ($editorService.ui.editingItem > ($editorService.data.images.length - 1)) {
                            $editorService.ui.editingItem = ($editorService.data.images.length - 1);
                        }

                        $canvasService.startTick();
                    }


                }


                function getCookie(cname) {
                    var name = cname + "=";
                    var decodedCookie = document.cookie;
                    var ca = decodedCookie.split(';');
                    for (var i = 0; i < ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) === ' ') {
                            c = c.substring(1);
                        }
                        if (c.indexOf(name) === 0) {
                            return atob(c.substring(name.length, c.length));
                        }
                    }
                    return "";
                }

                function setcookie(cookieName, cookieValue) {
                    var today = new Date();
                    var expire = new Date();
                    expire.setTime(today.getTime() + 3600000 * 24 * 15);
                    document.cookie = cookieName + "= " + btoa(cookieValue) + ";expires=" + expire.toGMTString();
                }


                this.search = function () {

                    $editorService.ui.imageSearchIsOpen = true;
                    setTimeout(function () {
                        if (document.getElementById('search-txt').value === "") {
                            document.getElementById('search-txt').focus();
                        }

                    }, 300)

                }

                this.upload = function () {
                    if (window.browserInfo !== undefined && window.browserInfo.mobile) {
                        if (window.browserInfo.os === 'ios') {
                            if (window.browserInfo.browser === 'facebook') {
                                return $tutorialService.showSlideOSFacebook();
                            } else if (window.browserInfo.browser === 'instagram') {
                                return $tutorialService.showSlideOSInstagram();
                            }
                        } else if (window.browserInfo.os === 'android') {
                            if (window.browserInfo.browser === 'facebook') {
                                return $tutorialService.showSlideAndroidFacebook();
                            } else if (window.browserInfo.browser === 'instagram') {
                                return $tutorialService.showSlideAndroidInstagram();
                            }
                        }
                    }
                    $editorService.uploadCare.value(null)
                    $editorService.uploadCare.openDialog();
                    $editorService.hideTools();
                }

                /**
                 * SelectImage form Controls!!! 
                 * 
                 * @param {*} $data 
                 * @param {*} $type 
                 * @param {*} $indexFromImageGalery 
                 */
                this.selectImage = function ($data, $type, $indexFromImageGalery) {

                    switch ($type) {

                        case "my_galery":

                            var u = $data.cdnUrl + ($data.fotocOwner ? '' : '-/resize/1024/');
                            var _editingItem = $editorService.ui.editingItem;

                            if ($editorService.ui.compositionsAsGroup) {

                                $editorService.ui.view = { type: 'edit', id: null };
                                if ($indexFromImageGalery === false) {
                                    $editorService.data.images.push({
                                        type: 'my_galery',
                                        frameColor: $editorService.ui.lastFrameColorSelected,
                                        data: $data,
                                        urlWithoutFilter: u,
                                        urlWithFilter: u,
                                        position: { x: 500, y: 500, rotation: 0, scaleX: 1, scaleY: 1 },
                                        userForce: true
                                    });
                                }

                                var pos_in_images = self.findPosUuid($data.uuid, true);

                                if (pos_in_images !== false) {

                                    $editorService.ui.editingItem = pos_in_images;

                                }
                            } else {
                                $editorService.data.images[_editingItem] = {
                                    type: 'my_galery',
                                    frameColor: $editorService.ui.lastFrameColorSelected,
                                    data: $data,
                                    urlWithoutFilter: u,
                                    urlWithFilter: u,
                                    position: {},
                                    userForce: true
                                }

                                $canvasService.setImage(u, true, _editingItem, false)
                                $editorService.setCacheImages(u);
                            }

                            break;

                        case "stock":

                            var extract_url = $editorService.extract_preview_url($data.assets.preview.url, $data.assets.preview.width, $data.assets.preview.height);
                            $editorService.data.images[$editorService.ui.editingItem] = {
                                type: 'stock',
                                data: $data,
                                frameColor: $editorService.ui.lastFrameColorSelected,
                                urlWithoutFilter: extract_url,
                                position: {},
                                userForce: true
                            }
                            $canvasService.setImage(extract_url, true, $editorService.ui.editingItem, false);
                            $editorService.setCacheImages($data.assets.large_thumb.url);

                            break;
                    }
                }
            }]
        })
})();